<template>
  <div class="container">
    <div class="add-user">
      <!-- 手机号 -->
      <div class="add-user-phone">
        <span>手机号:</span>
        <input
          v-reset-page
          type="number"
          value
          placeholder="请输入"
          oninput="if(value.length>11)value=value.slice(0,11)"
          @input="handleChangePhone"
          pattern="[0-9]*"
          v-model="phone"
        />
      </div>
      <!-- 姓名 -->
      <div class="add-user-name">
        <span>姓名:</span>
        <input v-reset-page type="text" value placeholder="请输入" v-model="name"     :disabled="isdisabled"/>
      </div>

      <!-- 性别 -->
      <div class="add-user-gender">
        <span>性别:</span>
        <span @click="isClickGender && handelGenderClick(1)">
          <img :src="genderIndex ==1 ? seleURL : noSeleURL" alt srcset />男
        </span>
        <span @click="isClickGender && handelGenderClick(2)">
          <img :src="genderIndex ==2 ? seleURL : noSeleURL " alt srcset />女
        </span>
      </div>
      <!-- 职务 -->
      <div class="add-user-duty">
        <span>职务:</span>
        <input v-reset-page type="text" value placeholder="请输入" v-model="duty" :disabled="isdisabled" />
      </div>
    </div>
    <!-- 点击保存 -->
    <div class="btn"  @click="handleSaveClick">保存</div>
  </div>
</template>

<script>
import { addUser, selectUserInfoPhone } from "@/api/user";
import { Toast } from "vant";
export default {
  data() {
    return {
      seleURL: require("@/images/select.png"),
      noSeleURL: require("@/images/noselect.png"),
      genderIndex: 0,
      gender: "",
      name: "",
      phone: "",
      duty: "",
      isdisabled:false,
      isClickGender:true
    };
  },
  methods: {
    // 选择性别
    handelGenderClick(genderIndex) {
      if (genderIndex == 1) {
        this.genderIndex = genderIndex;
        this.gender = "0";
      }
      if (genderIndex == 2) {
        this.genderIndex = genderIndex;
        this.gender = "1";
      }
    },
    handleChangePhone() {
      if (this.phone.length == 11) {
        this.isblur = true
        this.requestSelectUserInfoPhone();
      }
    },
    // 根据用户信息渲染用户信息
    requestSelectUserInfoPhone() {
      selectUserInfoPhone({ loginPhone: this.phone }).then(res => {
        console.log(res);
        if (res.data) {
          this.isdisabled = false;
          this.isClickGender = true;
          this.name = res.data.name;
          if (res.data.sex == "0") {
            this.genderIndex = 1;
              this.gender = "0";
          }
          if (res.data.sex == "1") {
            this.genderIndex = 2;
            this.gender = "1";
          }
          this.duty = res.data.duty;
        }else {
          this.isdisabled = false;
          this.isClickGender = true;
          this.name = '';
          this.genderIndex = 0;
          this.duty = '';
        }
      });
    },
    // 添加用户
    requestAddUser() {
      let name = this.name;
      let phone = this.phone;
      let sex = this.gender;
      let duty = this.duty;
      let netBarId = this.$route.query.netBarId;
      // 为必填项
      if (!name) {
        Toast("姓名不能为空");
        return false;
      }
      if (!phone) {
        Toast("手机号不能为空");
        return false;
      }
      if (!sex) {
        Toast("请选择性别");
        return false;
      }
      if (!duty) {
        Toast("职务不能为空");
        return false;
      }
      addUser({
        name: name,
        loginPhone: phone,
        sex: sex,
        duty: duty,
        internetBarId: netBarId,
        role: 0
      }).then(res => {
        console.log(res);
        if (res.code == 200) {
          this.$router.go(-1);
        }else {
          Toast(res.message)
        }
      });
    },
    handleSaveClick() {
      this.requestAddUser();
    }
  }
};
</script>

<style scoped lang="scss">
.container {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  overflow-x: hidden;
  .add-user {
    width: 100%;
    height: 210px;
    background-color: #ffffff;
    margin-top: 10px;
    padding: 0 12px;
    box-sizing: border-box;
    text-align: left;
    font-size: 15px;
    color: #333333;
    // 姓名
    .add-user-name {
      width: 100%;
      height: 52px;
      line-height: 50px;
      border-bottom: 1px solid #f2f2f2;
      span {
        font-weight: bold;
        font-size: 15px;
      }
      input {
        border: none;
        margin-left: 60px;
        line-height: normal;
        font-size: 15px !important;
        color: #999999 !important;
        &::-webkit-input-placeholder {
          font-size: 15px;
          color: #999999;
        }
        &:disabled {
          background-color: #ffffff;
        }
      }
    }
    // 手机号
    .add-user-phone {
      width: 100%;
      height: 52px;
      line-height: 50px;
      border-bottom: 1px solid #f2f2f2;
      span {
        font-weight: bold;
        font-size: 15px;
      }
      input {
        border: none;
        margin-left: 46px;
        line-height: normal;
        font-size: 15px !important;
        color: #999999 !important;
        &::-webkit-input-placeholder {
          font-size: 15px;
          color: #999999;
        }
        &:disabled {
          background-color: #ffffff;
        }
      }
    }
    // 性别
    .add-user-gender {
      width: 100%;
      height: 52px;
      line-height: 50px;
      border-bottom: 1px solid #f2f2f2;
      span {
        &:first-child {
          font-weight: bold;
          font-size: 15px;
        }
        &:nth-child(2) {
          margin-left: 60px;
        }
        &:last-child {
          margin-left: 20px;
        }
        img {
          width: 15px;
          height: 15px;
          vertical-align: middle;
          margin-right: 10px;
        }
      }
    }
    // 职务
    .add-user-duty {
      width: 100%;
      height: 50px;
      line-height: 50px;
      span {
        font-weight: bold;
        font-size: 15px;
      }
      input {
        border: none;
        margin-left: 60px;
        line-height: normal;
        font-size: 15px !important;
        color: #999999 !important;
        &::-webkit-input-placeholder {
          font-size: 15px;
          color: #999999;
        }
        &:disabled {
          background-color: #ffffff;
        }
      }
    }
  }
  // 点击保存
  .btn {
    width: 350px;
    height: 44px;
    background: -webkit-linear-gradient(left, #05aefc, #008cff);
    border-radius: 22px;
    font-size: 16px;
    color: $white-color;
    line-height: 44px;
    margin: 0 auto;
    text-align: center;
    margin-top: 308px;
  }
}
</style>
